module.exports = __webpack_public_path__ + "312c3e27f2b7050e7a9877f6e1796559.pdf";